import gql from 'graphql-tag';

export const suggestedDokkioTagFragment = gql`
  fragment suggestedDokkioTagFragment on SuggestedDokkioTag {
    dokkioClass
    accountID
    id
    confidence
    name
    suggestedDokkioTagType
    dokkioLabelNames
    objectCount
  }
`;
export default suggestedDokkioTagFragment;
